var map = {
	"./ABOUT_US.png": 74663,
	"./Brush.png": 54545,
	"./CHANG_LONG_REMINDER.png": 86804,
	"./DRAW_CENTER.png": 36736,
	"./TREND_CHART.png": 85759,
	"./download.png": 3832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90379;